export default "__VITE_ASSET__75229005__"